<template>
  <section>
    <div v-if="(isHome() || isViewAllPage()) && !isMyProfile()"
         class="hero"
         role="banner">
      <div class="overlay-container">
        <div class="banner-container homePage">
          <div class="banner-logo">
            <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FBuckeye%2Fbsef-logo.jpg?alt=media&token=96f771be-39bc-4126-9f29-e0d87be21090" alt="BSEF Logo">
          </div>
          <div class="banner-text">
            <h1>Finalist Exhibit Hall</h1>
            <p>The <span class="has-text-weight-bold">Buckeye Science & Engineering Fair (BSEF)</span> provides all Ohio’s students in grades 9-12 with an opportunity to qualify for the International Science & Engineering Fair (ISEF). The ISEF is the largest and most prestigious science fair in the world. Each year over 1,700 students from more than 70 countries, regions, and territories around the world gather to compete for nearly $5,000,000 in awards and scholarships.</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isCollegePage()"
         class="hero"
         role="banner">
      <div class="overlay-container overlay-container_collegePage">
        <div class="banner-container collegePage">
          <div class="banner-logo banner-logo_collegePage">
            <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FBuckeye%2Fbsef-logo.jpg?alt=media&token=96f771be-39bc-4126-9f29-e0d87be21090" alt="BSEF Logo">
          </div>
          <div class="banner-text banner-text_collegePage">
            <h1>Institutional Partners &<br>College Exhibit</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

export default {
  methods: {
    isHome: function () {
      return this.$route.fullPath.includes('home')
    },
    isViewAllPage: function () {
      return this.$route.fullPath.includes('viewAll')
    },
    isCollegePage: function () {
      return this.$route.fullPath.includes('/explore/institutional-partners-and-colleges')
    },
    isMyProfile: function () {
      return this.$route.fullPath.includes('profile')
    }
  }
}

</script>
<style lang="scss" scoped>
@import '~styles/utils.scss';
.hero {
  display: flex;
  justify-content: center;
  background-image: url("https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FBuckeye%2FBuckeye_banner_bg.jpg?alt=media&token=5e442cfb-9731-4de6-add1-aa158247d86a");
  height: 450px;
  background-size: cover;
  background-position: center;
  font-family: 'Arial';
  color: white;
  font-weight: 400;
}
.overlay-container {
  background-color: rgba(14, 55, 99, 0.8);
  display: flex;
  margin: auto;
  padding: 40px 40px 40px 60px;
}
.banner-container {
  display: flex;
  flex-direction: row;
  height: 100%;
  margin: auto;
  align-items: center;
}
.banner-logo {
  width: 250px;
  flex-shrink: 0;
  &_collegePage {
     padding-top: 10px;
     width: 200px;
  }
}
.banner-text {
  padding: 0 30px 0 30px;
  max-width: 600px;
  h1 {
    font-size: 1.8em;
    font-weight: 600;
    padding: 10px 0 10px 0;
  }
  p {
    font-size: 1.1em;
  }
  span {
    font-size: 1.05em;
  }
}

@include touch {
  .overlay-container {
    padding: 40px;
    height: 100%;
    width: 100%;
  }
  .banner-logo {
    display: none;
  }
  .banner-logo_collegePage {
    display: block;
  }
}
@include mobile {
  .overlay-container {
    padding: 15px;
  }
  .banner-logo_collegePage {
    display: block;
    width: 140px;
    margin-left: 15px;
  }
  .banner-text {
    padding: 0 0 0 30px;
    max-width: 600px;
    h1 {
      font-size: 1.6em;
      font-weight: 600;
      padding: 5px 0 5px 0;
    }
    &_collegePage h1 {
       font-size: 1.3em;
       font-weight: 600;
     }
    p {
      font-size: 1em;
    }
    span {
      font-size: 1.05em;
    }
  }
}
</style>
